import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=6e839654&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&id=6e839654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e839654",
  null
  
)

export default component.exports